
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","height":"28","viewBox":"0 0 30 28","width":"30","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#b2895f"}},[_c('path',{attrs:{"d":"m3.23325 23.8334v.1h.1 13.33335.1v-.1-1.25-.1h-.1-1.6292v-6.275c0-1.1881-.3541-2.2477-1.0622-3.1752-.6926-.9074-1.5967-1.4876-2.7086-1.7387v-.5236c0-.3466-.1258-.6377-.3765-.86565-.2482-.22563-.5467-.3385-.89018-.3385-.34346 0-.64198.11287-.89019.3385-.25074.22795-.37648.51905-.37648.86565v.5236c-1.11181.2511-2.01261.8314-2.69853 1.739-.70094.9276-1.05147 1.987-1.05147 3.1749v6.275h-1.65-.1v.1zm5.1.7333h-.1v.1c0 .4858.17788.9038.53004 1.2486.35099.3437.76462.5181 1.23663.5181.48508 0 .90278-.1739 1.24778-.5189s.5189-.7627.5189-1.2478v-.1h-.1zm5.25415-2.0833h-7.15415v-6.275c0-1.0017.34747-1.8514 1.04397-2.5546.69626-.703 1.54211-1.0537 2.54358-1.0537 1.0014 0 1.8435.3506 2.5327 1.0533.6897.7032 1.0339 1.553 1.0339 2.555z","stroke":"#b2895f","stroke-width":".2"}}),_c('path',{attrs:{"clip-rule":"evenodd","d":"m21.3334 7.33342v-4.00001c0-.36819.2985-.66666.6667-.66666s.6666.29847.6666.66666v4.00001h4c.3682 0 .6667.29847.6667.66666s-.2985.66667-.6667.66667h-4v3.99995c0 .3682-.2984.6667-.6666.6667s-.6667-.2985-.6667-.6667v-3.99995h-4c-.3682 0-.6667-.29848-.6667-.66667s.2985-.66666.6667-.66666z","fill-rule":"evenodd"}})])])
          )
        }
      }
    